import React from 'react';
import { Button } from 'antd';
import CommonListsIndex from '../../components/CommonLists/index';
import SiteList from './list';

class Site extends CommonListsIndex {
  constructor() {
    super();
    this.api = 'site';
    this.addComponent = ``;
    this.editComponent = ``;
    this.listsComponent = SiteList;
  }
  componentDidMount() {
    this.freshQueryList();
    this.editComponent = `/content/site/id/edit`;
    this.addComponent = `/content/site/add`;
  }

  freshQueryList = () => {
    this.queryList({});
  };

  render() {
    const ListsComponent = this.listsComponent;
    return (
      <div>
        <div className="tantuer-op">
          <Button type="primary" icon="plus" onClick={this.add}>
            新增
          </Button>
        </div>

        <ListsComponent
          data={this.state.listsData}
          edit={this.edit}
          queryList={this.freshQueryList}
        />
      </div>
    );
  }
}
export default Site;
